<template>
    <div class="block-editor table-update-record">
        <div class="wrapper">
            <section>
                <div class="editor-row-title">Table ID</div>
                <div class="table-selection-row">
                    <CustomPicker
                        v-model="clone.tableId"
                        :items="tables"
                        idKey="_id"
                        labelKey="name"
                        title="Select Table"
                    />
                    <SupsisButton v-if="clone.tableId" class="go-to-table-btn" @click="goToTable" ghost>
                        <i class="material-icons">visibility</i>
                        Tabloya Git
                    </SupsisButton>
                </div>
            </section>
            <section>
                <div class="title">Record ID</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        placeholder="Record ID"
                        :show-attributes="true"
                        :show-emoji="true"
                        :max-character-count="1024"
                        v-model="clone.recordId"
                    />
                </div>
            </section>
            <section v-if="getSelectedTable()">
                <div class="title">Update Fields</div>
                <div v-for="(fieldItem, index) in clone.fields" :key="fieldItem.id" class="field-row">
                    <CustomPicker
                        v-model="fieldItem.fieldId"
                        :items="
                            getSelectedTable()
                                .fields.filter((f) => !f.fieldType.startsWith('record_'))
                                .filter((f) => f.fieldType !== 'lookup')
                                .filter((f) => f.fieldType !== 'formula')
                        "
                        idKey="_id"
                        labelKey="name"
                        title="Select Field"
                    />
                    <div class="field-value-col">
                        <div v-if="isMultiAssetField(fieldItem.fieldId)" class="multi-asset-hint">
                            <i class="material-icons">info_outline</i>
                            <span>{{ $t('auto.createRecordMultiAssetTooltip') }}</span>
                        </div>
                        <div class="text-editor-wrapper">
                            <TiptapEditor
                                placeholder="Value"
                                :show-attributes="true"
                                :show-emoji="true"
                                :max-character-count="1024"
                                v-model="fieldItem.value"
                            />
                        </div>
                    </div>
                    <button @click="removeField(index)">{{ $t("message.delete") }}</button>
                </div>
                <button @click="addField">+ {{ $t("calendar.addField") }}</button>
            </section>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import _ from "lodash";
import { mapState } from "vuex";
import CustomPicker from "../../../../../../../components/pickers/CustomPicker.vue";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import SupsisButton from "../../../../../../../views/Pages/Settings/components/SupsisButton.vue";

const log = log2("UpdateRecord");
export default {
    name: "UpdateRecord",
    components: { CustomPicker, TiptapEditor, SupsisButton },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    computed: {
        ...mapState({
            tables: (state) => state.table.tables,
        }),
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
    methods: {
        addField() {
            if (!this.clone.fields) {
                this.$set(this.clone, "fields", []);
            }
            this.clone.fields.push({
                id: _.uniqueId(),
                fieldId: null,
                value: "",
                mode: "dynamic",
            });
        },
        removeField(index) {
            this.clone.fields.splice(index, 1);
        },
        getSelectedTable() {
            return this.tables.find((table) => table._id === this.clone.tableId);
        },
        isMultiAssetField(fieldId) {
            if (!fieldId) return false;
            var table = this.getSelectedTable();
            if (!table) return false;
            var field = table.fields.find(function (f) { return f._id === fieldId; });
            if (!field) return false;
            var multiTypes = ["multi-file", "multi-image", "multi-video", "multi-audio"];
            return multiTypes.indexOf(field.fieldType) !== -1;
        },
        goToTable() {
            if (this.clone.tableId) {
                this.$router.push(`/tables/t/${this.clone.tableId}`);
            }
        },
    },
};
</script>

<style lang="scss">
.block-editor.table-update-record {
    section {
        margin-bottom: 10px;
    }

    .wrapper {
        padding: 30px;

        .title {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .table-selection-row {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 10px;

            .custom-picker {
                flex: 1;
            }

            .go-to-table-btn {
                flex-shrink: 0;
                display: flex;
                align-items: center;

                i {
                    margin-right: 5px;
                }
            }
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }

        .field-row {
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            .field-value-col {
                flex: 1;
                margin-left: 10px;

                .multi-asset-hint {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    margin-bottom: 4px;
                    font-size: 12px;
                    color: #1890ff;

                    .material-icons {
                        font-size: 14px;
                    }
                }
            }

            .text-editor-wrapper {
                flex: 1;
            }

            button {
                margin-left: 10px;
                background-color: #ff4d4f;
                color: #fff;
                border: none;
                padding: 5px 10px;
                cursor: pointer;

                &:hover {
                    background-color: #ff7875;
                }
            }
        }

        button {
            margin-top: 10px;
            background-color: #1890ff;
            color: #fff;
            border: none;
            padding: 8px 16px;
            cursor: pointer;

            &:hover {
                background-color: #40a9ff;
            }
        }
    }
}
</style>
